<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Elijah
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To teach that there is only one true and living God who is worthy of worship.
                        </li>
                        <li>
                            To teach that God will rescue those who trust in him alone and judge those who worship other gods.
                        </li>
                        <li>
                            To understand that God has spoken through his chosen prophets and that his word can always be trusted.
                        </li>
                        <li>
                            To understand that God achieves his big plan for the world through people he has called and equipped through the ages.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series covers the ministry of Elijah. His main task was to call Israel to repent of their idolatry and worship the Lord as the only true and living God. Baal and Asherah were storm and fertility gods believed to produce lightning and provide rain for crops to grow. Through Elijah the God of Israel exposed Baal to be a false god incapable of providing rain or preserving life.
                    </p>
                    <p>
                        Week 1 deals with Elijah’s initial challenge to King Ahab – there would be no dew or rain until Elijah, the mouthpiece of the one true God, declared otherwise. This challenge struck at the heart of Baal’s power in the minds of his worshippers – his ability to provide rain. The Lord brought Israel to their knees with a three-year drought that culminated in a final contest between the Lord and Baal on Mount Carmel (week 2). The god that answered his worshippers’ prayers by fire would be declared to be the only true God. After a decisive victory on Carmel, Elijah (under threat of death from Ahab’s wicked wife, Jezebel) fled to Mount Horeb (week 3) believing that he was all alone. But God graciously met with Elijah and reminded him that there were over 7,000 faithful Israelites – he was not alone. There was no need for a new covenant and Elijah should continue the work that God had given him to do by appointing Elisha to succeed him as Israel’s spiritual leader. Elijah appointed Elisha before being taken to heaven in a whirlwind (week 4).
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - Elijah and the Drought (1 Kings 16:29 - 17:24)
                    </p>
                    <p>
                        Lesson 2 - Elijah on Mount Carmel (1 Kings 18:1-46)
                    </p>
                    <p>
                        Lesson 3 - Elijah on Mount Horeb (1 Kings 19:1-18)
                    </p>
                    <p>
                        Lesson 4 - Elijah and Elisha (1 Kings 19:19-21, 2 Kings 2:1-18)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Elijah",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Elijah`,
            meta: [
                {
                    name: 'description',
                    content: "To teach that there is only one true and living God who is worthy of worship.",
                },
            ],
        };
    },
};
</script>
